import React from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";

const FindUserWrapper = styled.div`
  margin: 20px 0;
`;

const UserTable = styled.table`
  width: 100%;
  font-family: sans-serif;
  border-collapse: collapse;
  text-align: left;
  tbody,
  th,
  td {
    border: 1px solid black;
  }
  tbody {
  }
  th {
    font-size: 20px;
    height: 50px;
  }
  td {
    padding: 5px;
  }
  tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

const FindUser = ({ allUsers, history }) => {
  return (
    <>
      <FindUserWrapper>Click on a user to edit his profile</FindUserWrapper>
      <UserTable>
        <tbody>
          <tr>
            <th>Email</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Owns Course?</th>
            <th>Admin?</th>
          </tr>
          {allUsers.map((user, index) => {
            return (
              <tr
                key={index}
                onClick={() => {
                  history.push(`/admin/editUser/${user.email}`);
                }}
              >
                <td>{user.email}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.ownsCourse ? "Yes" : "No"}</td>
                <td>{user.admin ? "Yes" : "No"}</td>
              </tr>
            );
          })}
        </tbody>
      </UserTable>
    </>
  );
};

export default withRouter(FindUser);
